"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_LANGUAGES = void 0;
var LANG_DEFINITIONS = require("../static/languagesData.json");
exports.ALL_LANGUAGES = LANG_DEFINITIONS;
